// extracted by mini-css-extract-plugin
export default {"LoadError":"bfo_a bia_qs bia_a bia_w bia_j bia_q","LoadError__icon":"bfo_b bia_vl bia_fm bia_sw","LoadError__message":"bfo_c bia_fm bia_tr"};